import * as React from 'react';

/**
 * We can't mock out React.Suspense with jest spyOn(), so
 * wrap react suspense in a simple getter that can be mocked
 * in tests.
 */
export const getReactSuspense = () => React.Suspense;
